import { getQuery, execQuery, luaScript, getVers } from '../../helpers/helper_store';
import moment from 'moment';
const state = {
	treeData: null,
	curPlace: null,
	curNode: null,
	curPlaceForExpand: null,
	parentServerId: null,
	parentSectId: null,
	typeSrv: null,
	typeDb: null,
	typeApi: null,
	typeParam: null,
	existBases: null,
	basesInSection: [],
	curInfo: null,
	dates: [],
	notSyncServers: [],
};

/*dates = [
{idServer: 1,
dateEdit: ...,
dateSave: ...
}	
]*/

function serialTree(json) {
	for (var key in json) {
		var value = json[key];
		if (typeof value === 'object') {
			value = setLId(value, json);
			serialTree(value);
		}
	}
	return json;
}

function setLId(curNode, parentNode) {
	let lId;
	const reg = new RegExp('_0', 'g');
	if (parentNode.children && parentNode.children.length > 0) {
		if (parentNode.lId) lId = parentNode.lId + '_' + (parentNode.children.indexOf(curNode) + 1);
		else lId = parentNode.children.indexOf(curNode) + 1;
	}
	else if (!parentNode.hasOwnProperty('children')) {
		if (parentNode.lId) lId = parentNode.lId + '_' + (parentNode.indexOf(curNode) + 1);
		else lId = parentNode.indexOf(curNode) + 1;
	}
	else return;
	let lID = lId.toString().replace(reg, '');
	curNode.lId = lID;
	return curNode;
}

function lookInTreeByLId(json, parentId) {
	let idArray = parentId.split('_');
	//console.log(idArray);
	let res = json[parseInt(idArray[0]) - 1];
	for (let i = 1; i < idArray.length; i++) {
		res = res.children[parseInt(idArray[i]) - 1];
	}
	return res;
}

function lookInTree(json, id, type) {
	if (json.id === id && json.type === type) {
		return json;
	}
	var result, key;
	for (key in json) {
		if (json.hasOwnProperty(key) && typeof json[key] === 'object') {
			result = lookInTree(json[key], id, type);
			if (result) {
				return result;
			}
		}
	}
	return result;
}

function workWithDates(server, state, serversArray) {
	// console.log(server);
	let serverDate = {
		idServer: server.id,
		dateEdit: server.dateEdit,
		dateSave: server.dateSave
	};
	updateDate(state, serverDate);
	let dateE = moment(serverDate.dateEdit, 'YYYY-MM-DD HH:mm:ss');
	let dateS = moment(serverDate.dateSave, 'YYYY-MM-DD HH:mm:ss');
	// console.log('dateE ', dateE);
	// console.log('dateS ', dateS);
	// console.log(dateE.isValid());
	let serverFromTable = serversArray.find((s) => s.serverID === server.id);
	// console.log(serverFromTable);
	// console.log(serversArray);
	if (serverFromTable.serverTypeSrvID !== '1' && serverFromTable.tiny !== null) {
		// console.log('dateE ', dateE);
		// console.log('dateS ', dateS);
		// console.log('IN IF ', serverFromTable);
		if (!dateS.isValid() && dateE.isValid()) {
			//если был редактирован, но в сохранении null
			state.notSyncServers.push(serverDate.idServer);
		}
		else if (dateE.isAfter(dateS) && dateE.isValid() && dateS.isValid()) {
			//если есть обе даты и редактироавние было позже
			// console.log('In here');
			state.notSyncServers.push(serverDate.idServer);
		}
	}
}
function updateDate(state, serverDate) {
	let dateExisted = false;
	for (let date of state.dates) {
		if (date.idServer === serverDate.idServer) {
			date.dateEdit = serverDate.dateEdit;
			date.dateSave = serverDate.dateSave;
			dateExisted = true;
		}
	}
	if (!dateExisted) {
		state.dates.push(serverDate);
	}
}

const mutations = {
	setConfigTreeData: (state, { serversArray, data }) => {
		state.dates = [];
		state.notSyncServers = [];
		state.treeData = serialTree(data);
		data.forEach((server) => {
			workWithDates(server, state, serversArray);
		});
	},
	setDates: ({state, rootState}) => {
		if (!!state.treeData) {
			state.dates = [];
			state.notSyncServers = [];
			rootState.common.serversArray.forEach((server) => {
				workWithDates(server, state, rootState.reference.serverTableArray);
			});
		}
	},
	setCurNode: (state, node) => {
		if(node){
			state.curPlace = node.lId;
		}
		else state.curPlace = null;
		state.curNode = node;
	},

	setCurPlaceForExpand: (state, lId) => (state.curPlaceForExpand = lId),
	setParentId(state, parentId) {
		state.parentSectId = null;
		state.parentServerId = null;
		let res;
		res = state.treeData[parseInt(parentId) - 1];
		// console.log('parentId' ,parentId);
		// console.log(res);
		state.parentServerId = res.id;
		if (parentId.indexOf('_') !== -1) {
			res = lookInTreeByLId(state.treeData, parentId);
			state.parentSectId = res.id;
		}
		// console.log('state server: ', state.parentServerId);
		// console.log('state app: ', state.parentSectId);
	},
	setTypeSrv: (state, type) => (state.typeSrv = type),
	setTypeDb: (state, type) => (state.typeDb = type),
	setTypeApi: (state, type) => (state.typeApi = type),
	setTypeParam: (state, type) => (state.typeParam = type),
	setExistBases: (state, bases) => (state.existBases =  Array.isArray(bases) ? bases : [ bases ]),
	setBasesInSection: (state, bases) => (state.basesInSection = Array.isArray(bases) ? bases : [ bases ]),
	setCurInfo: (state, info) => (state.curInfo = info),
};

const actions = {
	getConfigTree({ commit, rootState }) {
		return new Promise((resolve, reject) => {
			luaScript('katemap', 'run', null, rootState.login)
				.then((result) => {
					commit('setConfigTreeData', { serversArray: rootState.reference.serversTableArray, data: result });
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getAllTypes({ commit, rootState, dispatch }) {
		if (rootState.login.user !== null) {
			let pr1 = getQuery('getTypeSrvTable', null, rootState.login);
			let pr2 = getQuery('getTypeDbTable', null, rootState.login);
			let pr3 = getQuery('getTypeApiTable', null, rootState.login);
			let pr4 = getVers(rootState.login.base.url);
			// let pr4 = getQuery('getSectionNewParamType', [ '0' ], rootState.login);

			return new Promise((resolve, reject) => {
				Promise.all([ pr1, pr2, pr3, pr4 ])
					.then((values) => {
						commit('setTypeSrv', values[0]);
						commit('setTypeDb', values[1]);
						commit('setTypeApi', values[2]);
						// commit('setTypeParam', values[3]);
						commit('setMainVers', values[3]);
						return dispatch('getRoles');
					})
					.then(() => {
						return dispatch('getRoleTable');
					})
					.then(()=>{
						resolve();
					})
					.catch((error) => {
						commit('setError', error);
						reject();
					});
			});
		}
	},
	getSectionParamType({ rootState, commit }, sectionId) {
		//console.log('sectionId', sectionId);
		return new Promise((resolve, reject) => {
			getQuery('getSectionNewParamType', [ sectionId ], rootState.login)
				.then((result) => {
					commit('setTypeParam', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getSectionAllParamType({ rootState, commit }) {
		//console.log('sectionId', sectionId);
		return new Promise((resolve, reject) => {
			getQuery('getSectionParamType', null, rootState.login)
				.then((result) => {
					commit('setTypeParam', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getExistBasesPS(context, serverId) {
		return new Promise((resolve, reject) => {
			getQuery('getBaseNotSectionPerServer', [ context.state.parentSectId, serverId ], context.rootState.login)
				.then((result) => {
					context.commit('setExistBases', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getBasesSection({ commit, rootState }, sectionId) {
		const user = rootState.login.user;
		let func;
		if(user.roleid === "0" || user.roleid === "1" || user.userid === "0" || user.userid === "1"){
			func = getQuery('getBaseSection', [ sectionId ], rootState.login);
		}
		else {
			func = getQuery('getAllowedBasesSection', [ sectionId, user.roleid ], rootState.login);
		}			
		return new Promise((resolve, reject) => {
			func
				.then((result) => {
					result = Array.isArray(result) ? result : [result];
					commit('setBasesInSection', result);
					resolve(result);
				})
				.catch(() => {
					reject();
				});
		});
	},
	addAppParam(context, node) {
		return new Promise((resolve, reject) => {
			execQuery(
				'addSectionOnlyParam',
				[ context.state.parentSectId, node.idParam, node.value ],
				context.rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	addBaseSection(context, node) {
		return new Promise((resolve, reject) => {
			execQuery('addBaseSection', [ context.state.parentSectId, node.id ], context.rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	insBaseTable({ dispatch, rootState, state }, { node, mode }) {
		let promise;
		if (mode === 'runScript') {
			node.idSection = state.parentSectId;
			promise = new Promise((resolve, reject) => {
				luaScript('newDBLinker', 'run', node, rootState.login)
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			});
		}
		else if (mode === 'linkExisted') {
			promise = new Promise((resolve, reject) => {
				dispatch('addBaseSection', node)
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			});
		}
		else if (mode === 'fullIns') {
			promise = new Promise((resolve, reject) => {
				execQuery(
					'insBaseTable',
					[
						node.nameSelected,
						node.shortNameSelected,
						node.aliasSelected,
						node.commentSelected,
						node.baseSelected,
						node.serverSelected
					],
					rootState.login
				)
					.then((result) => {
						node.id = result.rowid;
						return dispatch('addBaseSection', node);
					})
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			});
		}
		return promise;
	},
	delBase({ rootState, state }, { id, action }) {
		// console.log(state);
		return new Promise((resolve, reject) => {
			luaScript(
				'newDBeraser',
				'run',
				{
					idSection: state.parentSectId,
					idBase: id,
					action: action
				},
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	insSectionTable({ rootState }, node) {
		return new Promise((resolve, reject) => {
			execQuery(
				'insSectionTable',
				[
					node.nameSelected,
					node.aliasSelected,
					node.pathSelected,
					node.serverSelected,
					node.apiSelected,
					node.webAppSelected
				],
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delSectionHard({ commit, rootState }, id) {
		return new Promise((resolve, reject) => {
			luaScript('appclone', 'erase', { dropID: id }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delServerTable({ rootState }, id) {
		return new Promise((resolve, reject) => {
			execQuery('delServerTable', [ id ], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getInfo({ commit, rootState }, { id, getFn }) {
		return new Promise((resolve, reject) => {
			getQuery(getFn, [ id ], rootState.login)
				.then((result) => {
					commit('setCurInfo', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	updTable({ rootState }, { updFn, updArray }) {
		return new Promise((resolve, reject) => {
			execQuery(updFn, updArray, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	exportConfig({ rootState }, serverId) {
		return new Promise((resolve, reject) => {
			luaScript(
				'remoteManagerCfg',
				'run',
				{
					server: `${serverId}`
				},
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delSectionParam({ rootState }, id) {
		return new Promise((resolve, reject) => {
			execQuery('delSectionOnlyParam', [ id ], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	copySection({ rootState }, { name, path, alias, origID }) {
		return new Promise((resolve, reject) => {
			luaScript('appclone', 'clone', { name, alias, path, origID }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getCurServerManagerDate({rootState}, serverId){
		return new Promise((resolve, reject) => {
			luaScript("managerInfo", "fileTime", {server: serverId}, rootState.login).then((result) => {
				// const time = moment(result.mtime);
				resolve(result);
			}).catch((err) => reject(err))
		})
	},
	getCurServerManagerFile({rootState}, serverId){
		return new Promise((resolve, reject) => {
			luaScript("managerInfo", "fileView", {server: serverId}, rootState.login).then((result) => {
				resolve(result);
			})
			.catch((err) => reject(err))
		})
	}
};

const getters = {
	getConfigTree: (state) => state.treeData,
	getCurPlace: (state) => state.curPlace,
	curNode: (state) => state.curNode,
	getCurPlaceForExpand: (state) => state.curPlaceForExpand,
	getParentServerId: (state) => state.parentServerId,
	getParents: (state) => [ state.parentServerId, state.parentSectId ],
	getTypeSrv: (state) => state.typeSrv,
	getTypeDb: (state) => state.typeDb,
	getTypeApi: (state) => state.typeApi,
	getTypeParam: (state) => state.typeParam,
	getExistBases: (state) => state.existBases,
	getBasesInSection: (state) => state.basesInSection,
	getCurInfo: (state) => state.curInfo,
	getDates: (state) => state.dates,
	getNotSyncServers: (state) => state.notSyncServers
};

export default {
	state,
	mutations,
	actions,
	getters
};
